import React, { useState } from 'react'; 
import { Link } from 'react-router-dom'
import Logo from '../Images/logo.jpg'
const Header = () => { 
    const Logout = ()=>{
      sessionStorage.clear()
      window.location.href="/"
    }
	return ( 
		<div> 
	<nav class="navbar navbar-expand-lg " style={{backgroundColor:""}}>
  <div class="container-fluid">
    <a class="navbar-brand" href="/ticket" style={{color:"#000",fontWeight:"900"}}>
      {/* <img src={Logo} style={{width:"10vw"}}/> */}
      <h3>LOGO HERE</h3>
      </a>
    <button class="navbar-toggler custom-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
  <span class="navbar-toggler-icon" style={{backgroundColor:"#fff"}}></span>
</button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
    <li class="nav-item mt-2">
      <Link to="/ticket" style={{textDecoration:"none",marginRight:"10px"}}> 
      <button type="button" class="btn" style={{border:"1px solid skyblue",backgroundColor:"#fff",color:"#000"}}>
      <i class="fa fa-home" style={{fontSize:"20px",cursor:"pointer",color:"skyblue"}} aria-hidden="true"></i>
      </button>
      </Link>
        </li>
        <li class="nav-item mt-2">
        <Link to="/technician" style={{textDecoration:"none",marginRight:"10px"}}> 
        <button type="button" class="btn" style={{border:"1px solid skyblue",backgroundColor:"#fff",color:"#000"}}><span style={{fontSize:"15px",cursor:"pointer",marginRight:"10px"}}><i class="fa fa-user" style={{color:"skyblue"}} aria-hidden="true"></i></span>Technician</button>
        </Link>
        </li>
        <li class="nav-item mt-2">
        <Link to="/dealer" style={{textDecoration:"none",marginRight:"10px"}}> 
        <button type="button" class="btn" style={{border:"1px solid skyblue",backgroundColor:"#fff",color:"#000"}}><span style={{fontSize:"15px",cursor:"pointer",marginRight:"10px"}}><i class="fa fa-user" style={{color:"skyblue"}} aria-hidden="true"></i></span>Dealer</button>
        </Link>
        </li>
        <li class="nav-item mt-2">
        <Link to="/ticket" style={{textDecoration:"none",marginRight:"10px"}}> 
        <button type="button" class="btn" style={{border:"1px solid skyblue",backgroundColor:"#fff",color:"#000"}}><span style={{fontSize:"15px",cursor:"pointer",marginRight:"10px"}}><i class="fa fa-ticket" style={{color:"skyblue"}} aria-hidden="true"></i></span>Ticket</button>
        </Link>
        </li>
        <li class="nav-item mt-2">
        <Link to="/charges" style={{textDecoration:"none",marginRight:"10px"}}> 
        <button type="button" class="btn" style={{border:"1px solid skyblue",backgroundColor:"#fff",color:"#000"}}><span style={{fontSize:"15px",cursor:"pointer",marginRight:"10px"}}><i class="fa fa-ticket" style={{color:"skyblue"}} aria-hidden="true"></i></span>Charges</button>
        </Link>
        </li>
        <li class="nav-item mt-2">
        <Link to="/profile" style={{textDecoration:"none",marginRight:"10px"}}> 
        <button type="button" class="btn" style={{border:"1px solid skyblue",backgroundColor:"#fff",color:"#000"}}><span style={{fontSize:"15px",cursor:"pointer",marginRight:"10px"}}><i class="fa fa-user" style={{color:"skyblue"}} aria-hidden="true"></i></span>Profile</button>
        </Link>
        </li>

        <li class="nav-item mt-2">
        <button type="button" onClick={Logout} class="btn" style={{border:"1px solid skyblue",backgroundColor:"#fff",color:"#000"}}>
        <span>
          <i class="fa fa-power-off" style={{fontSize:"20px",cursor:"pointer",color:"red"}} aria-hidden="true"></i>
        </span>
        </button>
        </li>
      </ul>
    </div>
  </div>
</nav>
		</div> 
	); 
} 
export default Header;
